import { render, staticRenderFns } from "./showDeal.vue?vue&type=template&id=14963b92"
import script from "./showDeal.vue?vue&type=script&lang=js"
export * from "./showDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports